import { EXIT_DIAGRAM, SET_IMAGE_CONSUMED } from '@src/type/ethos';

export const exitDiagram = () => ({ type: EXIT_DIAGRAM });

export const setImageConsumed = () => ({ type: SET_IMAGE_CONSUMED });
export const setMapConsumed = () => ({ type: 'SET_MAP_CONSUMED' });
